import React, { CSSProperties } from "react";
import {
  Box,
  Grid,
  Dialog,
  makeStyles,
  useTheme,
  useMediaQuery,
  Typography,
  IconButton,
  Slide,
} from "@material-ui/core";
import { TransitionProps } from "@material-ui/core/transitions";
import clsx from "clsx";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CloseIcon from "@material-ui/icons/Close";

const TransitionUP = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const TransitionLeft = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const TransitionRight = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="right" ref={ref} {...props} />;
});

const TransitionDown = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

// const Transition= React.forwardRef(function Transition(
// 	props: TransitionProps & { children?: React.ReactElement<any, any> },
// 	ref: React.Ref<unknown>,
// 	) {
// 	return <></>;
// 	});

export interface PopUpInterface {
  title?: string;
  open: boolean;
  handleClose: any;
  ExitIcon?: any;
  children: any;
  iconPosition?: "left" | "right";
  titleAlign?: "left" | "center" | "right";
  direction?: "down" | "left" | "right" | "up";
  onBack?: () => void;
  paperStyle?: CSSProperties;
  titleComponent?: React.ReactNode;
}

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 30,
    padding: theme.spacing(4),
    height: "100%",
  },
  dialog: {
    borderRadius: 30,
  },
  closeIcon: {
    color: theme.palette.primary.main,
    position: "absolute",
    // left:16,
  },
  iconLeft: {
    left: 16,
  },
  iconRight: {
    right: 16,
  },
}));

export const PopUp: React.FC<PopUpInterface> = ({
  open,
  title,
  handleClose,
  ExitIcon,
  direction,
  iconPosition,
  titleAlign,
  children,
  onBack,
  paperStyle,
  titleComponent,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const getTransitions = () => {
    switch (direction) {
      case "up":
        return TransitionUP;
      case "left":
        return TransitionLeft;
      case "right":
        return TransitionRight;
      case "down":
        return TransitionDown;
      default:
        return undefined;
    }
  };

  const getDefaultBackIcon = () => {
    if (onBack) {
      switch (direction) {
        case "up":
          return <ExpandMoreIcon />;
        case "down":
          //   return <ExpandMoreIcon style={{ transform: "rotate(180deg)" }} />;
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
        case "left":
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
        case "right":
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
        default:
          return <ExpandMoreIcon style={{ transform: "rotate(90deg)" }} />;
      }
    } else return null;
  };

  const onExit = () => {
    if (onBack) {
      return onBack();
    }
    handleClose();
  };

  const onClickOutSide = () => {
    handleClose();
  };

  return (
    <Dialog
      open={open}
      fullWidth
      fullScreen={useMediaQuery(theme.breakpoints.down("xs"))}
      TransitionComponent={getTransitions()}
      // onEscapeKeyDown={handleClose}
      onClose={onClickOutSide}
      classes={{ paper: classes.dialog }}
      PaperProps={{ style: paperStyle }}
      scroll="body"
    >
      <Box
        className={classes.root}
        display="flex"
        flexDirection="column"
        style={{ borderRadius: 30 }}
      >
        <Grid container alignItems="center" style={{ height: 40 }}>
          <IconButton
            className={clsx(classes.closeIcon, {
              [classes.iconLeft]:
                iconPosition === "left" || iconPosition === undefined,
              [classes.iconRight]: iconPosition === "right",
            })}
            onClick={onExit}
          >
            {ExitIcon || getDefaultBackIcon() || <CloseIcon />}
          </IconButton>
          {title !== undefined && (
            <Typography
              color="textPrimary"
              style={{ textAlign: titleAlign || "center", width: "100%" }}
              variant="subtitle1"
            >
              {title}
            </Typography>
          )}
          {titleComponent}
        </Grid>
        {children}
      </Box>
    </Dialog>
  );
};
